import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {NavigationActions} from "@app/state/navigation/navigation.actions";

@Injectable({
  providedIn: 'root',
})
export class PandaTemplateFlowResolver implements Resolve<any> {
  constructor(private store: Store) {}
  resolve(): Observable<any> {
    return this.store.dispatch([
      new NavigationActions.SetTemplateFlow(true)
    ])
  }
}

